import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import { IMAGES, INSTAGRAM_HANDLE, INSTAGRAM_URL } from "../constants/site";

export const InstagramSection = () => {
  return (
    <section id="instagram" data-testid="instagram-section" className="py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-16 flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between"
        >
          <div>
            <span className="text-xs uppercase tracking-[0.35em] text-[#C8A88B]">
              Keep up with the progress
            </span>
            <h2 className="mt-6 font-serif-display text-5xl font-light tracking-tight text-[#E6D5C3] lg:text-6xl">
              Follow the Haus
            </h2>
          </div>
          <a
            data-testid="instagram-follow-button"
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex w-fit items-center gap-3 border border-[#332A24] px-8 py-4 text-xs uppercase tracking-[0.2em] text-[#E6D5C3] transition-colors duration-200 hover:border-[#C8A88B] hover:text-[#DEBFA2]"
          >
            <Instagram size={16} strokeWidth={1.5} />
            {INSTAGRAM_HANDLE}
          </a>
        </motion.div>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 sm:gap-6">
          {IMAGES.instagram.map((src, i) => (
            <motion.a
              key={src}
              data-testid={`instagram-tile-${i + 1}`}
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.12 }}
              className={`group relative block overflow-hidden ${i % 3 === 1 ? "sm:mt-12" : ""}`}
            >
              <img
                src={src}
                alt={`Haus of Lash work — @la.hausoflash post ${i + 1}`}
                className="h-72 w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105 sm:h-80"
              />
              <div className="absolute inset-0 flex items-end bg-[#130F0D]/0 p-5 transition-colors duration-300 group-hover:bg-[#130F0D]/40">
                <span className="flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-[#E6D5C3] opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <Instagram size={12} strokeWidth={1.5} /> {INSTAGRAM_HANDLE}
                </span>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};
